const config = {
  API_BASE_URL:
    'http://localhost:1337/api/v1' ||
    'https://sept-backend.onrender.com/api/v1',
  AUTH_TOKEN: 'access_token=',
  AUTH_USER_ID: 'x-auth-user',
};

export default config;
